module.exports = __webpack_public_path__ + "static/media/by-sa.5dc38304.svg";